import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const tasksModule = {
  namespaced: true,
  state() {
    return {
      currentTask: {},
      currentFolder: {},
    };
  },
  actions,
  mutations,
  getters,
};

export default tasksModule;
